// extracted by mini-css-extract-plugin
export default {"dialogPaper":"CompensationDialog_dialogPaper__vGGLz"};